class AccordionCustom extends HTMLElement {
  constructor() {
    super();
    this.summary = this.querySelector('summary');
    this.content = this.querySelector('.accordion-custom__content');

    if (this.summary && this.content) {
      this.summary.addEventListener('click', (e) => this.onClick(e));
    }
  }

  onClick(e) {
    e.preventDefault();

    const isOpen = this.hasAttribute('open');

    if (isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.setAttribute('open', '');
    this.content.style.maxHeight = this.content.scrollHeight + 'px';
  }

  close() {
    this.content.style.maxHeight = this.content.scrollHeight + 'px';
    // Trigger reflow
    this.content.offsetHeight;
    
    this.content.style.maxHeight = '0px';

    // Wait for transition to finish before removing 'open' attribute
    setTimeout(() => {
      if (this.content.style.maxHeight === '0px') {
        this.removeAttribute('open');
      }
    }, 300); // matches CSS transition duration
  }
}

if (!customElements.get('accordion-custom')) {
  customElements.define('accordion-custom', AccordionCustom);
}
